import React from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import SuporteIAFlutuante from "../suporte-ia/SuporteIAFlutuante";
import { SUPORTE_WHATSAPP_URL } from "../config";
import "./layout.css";

export default function AppLayout({
  user,
  onLogout,
  currentPage,
  onNavigate,
  bloqueado = false,
  children,
}) {

  const WHATSAPP_LINK = SUPORTE_WHATSAPP_URL;

  return (
    <div className="app-shell">
      <Navbar user={user} onLogout={onLogout} currentPage={currentPage} onNavigate={onNavigate} bloqueado={bloqueado} />

      <div className="layout-body">
        <Sidebar currentPage={currentPage} onNavigate={onNavigate} user={user} />

        <main className="layout-content">
          {children}
        </main>
      </div>

      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        aria-label="Falar no WhatsApp"
        title="Falar no WhatsApp"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          window.open(WHATSAPP_LINK, "_blank", "noopener,noreferrer");
        }}
      >
        <svg
          width="26"
          height="26"
          viewBox="0 0 33 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M19.11 17.24c-.27-.14-1.6-.79-1.85-.88-.25-.09-.43-.14-.61.14-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.14-1.14-.42-2.17-1.34-.8-.71-1.34-1.6-1.5-1.86-.16-.27-.02-.41.12-.55.12-.12.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.14-.61-1.47-.84-2.01-.22-.53-.44-.46-.61-.46h-.52c-.18 0-.48.07-.73.34-.25.27-.95.93-.95 2.27 0 1.34.98 2.64 1.12 2.82.14.18 1.93 2.95 4.67 4.13.65.28 1.15.45 1.55.58.65.21 1.24.18 1.7.11.52-.08 1.6-.65 1.82-1.29.23-.64.23-1.18.16-1.29-.07-.11-.25-.18-.52-.32z"
          />
          <path
            fill="currentColor"
            d="M16 3C9.38 3 4 8.38 4 15c0 2.12.56 4.19 1.63 6.01L4 29l8.17-1.58A11.94 11.94 0 0 0 16 27c6.62 0 12-5.38 12-12S22.62 3 16 3zm0 21.5c-1.88 0-3.72-.51-5.32-1.48l-.38-.23-4.85.94.93-4.72-.25-.39A9.43 9.43 0 0 1 6.5 15C6.5 9.76 10.76 5.5 16 5.5S25.5 9.76 25.5 15 21.24 24.5 16 24.5z"
          />
        </svg>

      </a>

      <SuporteIAFlutuante />
    </div>
  );
}
